import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import { CREATE_ADMIN } from "../../../../graphql/mutations/management";
import { FETCH_ADMIN } from "../../../../graphql/queries/management";
import {
  clearAdminForm,
  clearSelectBranch,
  onChangeAdminForm,
  toggleAdminModal,
} from "../../redux/adminSlice";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";
import CustomSelect from "../../../../components/form/CustomSelect";
import {
  useBranchQuery,
  useQueryCurrentUser,
} from "../../../../graphql/apollo/query-hooks";

const AdminForm = () => {
  const dispatch = useDispatch();
  const { createForm } = useSelector((state) => state.admin);
  const { currentUser } = useQueryCurrentUser();

  const [createAdmin, { loading }] = useMutation(CREATE_ADMIN, {
    refetchQueries: [{ query: FETCH_ADMIN }],
    onCompleted: ({ createAdmin }) => {
      if (createAdmin) {
        dispatch(toggleAdminModal());
        showSuccessToast();
        dispatch(clearAdminForm());
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    createAdmin({ variables: { input: createForm } });
  };

  const handleChange = (e) => {
    dispatch(
      onChangeAdminForm({
        ...createForm,
        [e.target.name]: e.target.value,
      })
    );
  };

  const { branchList } = useBranchQuery();

  const options = branchList?.map((b) => ({
    value: b.id,
    label: b.name,
  }));
  const clearSelected = () => dispatch(clearSelectBranch());

  const handleChangeBranch = (e) =>
    dispatch(onChangeAdminForm({ ...createForm, branch: e.value }));

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ຊື່ເຕັມ"
        name="fullname"
        onChange={handleChange}
        type="text"
        value={createForm?.fullname}
        errorParam="name"
        required={true}
      />
      <CustomFormGroup
        label="username"
        name="username"
        onChange={handleChange}
        type="text"
        value={createForm.username}
        errorParam="engName"
        required={true}
      />
      <CustomFormGroup
        label="ລະຫັດຜ່ານ"
        name="password"
        onChange={handleChange}
        type="text"
        value={createForm?.password}
        required={true}
      />
      <CustomFormGroup
        label="ຢືນຢັນລະຫັດຜ່ານ"
        name="passwordConfirm"
        onChange={handleChange}
        type="text"
        value={createForm?.passwordConfirm}
        required={true}
      />
      {currentUser?.isSuperAdmin && (
        <>
          <Form.Label>ເລືອກຈຸສາຂາ</Form.Label>
          <Form.Group className="mb-3">
            <CustomSelect
              options={options}
              handleChange={handleChangeBranch}
              selected={createForm?.branch}
              placeholder="-- ເລືອກຈຸສາຂາ --"
              clearSelected={clearSelected}
            />
          </Form.Group>
        </>
      )}

      <div className="text-center">
        <SubmitButton loading={loading} />
      </div>
    </Form>
  );
};

export default AdminForm;
